import React from 'react';

const LoadingSpinner = ({ size = 'medium', message = 'Chargement...', minimal = false }) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12'
  };

  if (minimal) {
    return (
      <div className="flex items-center justify-center py-2">
        <div className={`${sizeClasses[size]} animate-spin`}>
          <div className="h-full w-full rounded-full border-2 border-orange-200 border-t-orange-600"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center space-y-3 py-6">
      <div className={`${sizeClasses[size]} animate-spin`}>
        <div className="h-full w-full rounded-full border-3 border-orange-200 border-t-orange-600 shadow-sm"></div>
      </div>
      <p className="text-gray-600 text-sm font-medium">{message}</p>
    </div>
  );
};

export default LoadingSpinner;